import sortInsurance from 'utils/sortInsurance';

const getOtherInsuranceNameID = ({ patient, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (patient
    && patient['Insurance Information']
    && patient['Insurance Information'].length > 1) {
    let otherInsurance = [];
    if (insurance) {
      otherInsurance = patient['Insurance Information'].filter(item =>
        item.ID !== insurance.ID)[0];
    } else {
      otherInsurance = sortInsurance(patient['Insurance Information'])[1];
    }
    return otherInsurance['Insurance Info']
      && otherInsurance['Insurance Info']['Payer Name']
      ? `${otherInsurance['Insurance Info']['Payer Name']} ${otherInsurance['Insurance ID']}`
      : otherInsurance['Insurance ID'];
  }
  return null;
};

export default getOtherInsuranceNameID;



// WEBPACK FOOTER //
// ./src/utils/print/getOtherInsuranceNameID.js